import React from 'react';

import { RegionSwitcherSelector } from '@amzn/d16-g-adsp-region-switcher-ui';
import { MarketplaceSwitcherProps } from 'src/features/header/components/MarketplaceSwitcher/MarketplaceSwitcher';
import { formatLocale } from 'src/providers/PantherLocalizationProvider/mbm';
import { useInternalChromeConfigContext } from 'src/providers/InternalChromeConfigContextProvider';
import { useAccountDropdownContext } from 'src/features/header/components/AccountDropdown/AccountDropdownProvider';
import { AccountGroup } from '@amzn/aac-chrome-internal-api';

const findCurrentAccount = (
  currentEntityId: string,
  currentMarketplaceId: string,
  accounts: AccountGroup[],
) => {
  let currentAccount;
  let regionalAccounts;

  for (const account of accounts) {
    for (const subAccount of account.accounts) {
      if (subAccount.entityId === currentEntityId) {
        if (subAccount.nestedAccounts) {
          regionalAccounts = subAccount.nestedAccounts;
          for (const nestedAccount of subAccount.nestedAccounts) {
            if (nestedAccount.marketplaceId === currentMarketplaceId) {
              currentAccount = nestedAccount;
              break;
            }
          }
          break;
        }
      }
    }
  }
  return [currentAccount, regionalAccounts];
};

const RegionSwitcher: React.VFC<MarketplaceSwitcherProps> = () => {
  const context = useAccountDropdownContext();

  const [currentAccount, regionalAccounts] = findCurrentAccount(
    context.currentEntityId,
    context.currentMarketplaceId,
    context.accounts,
  );

  const handleSelect = (selected) => {
    if (selected?.url) {
      const redirectUrl = new URL(`https://${selected.url}`);

      window.location.assign(redirectUrl.toString());
    }
  };

  const { config: internalChromeConfig } = useInternalChromeConfigContext();

  if (
    regionalAccounts == undefined ||
    currentAccount == undefined ||
    (Array.isArray(regionalAccounts) && regionalAccounts.length == 0)
  ) {
    return null;
  }
  return (
    <RegionSwitcherSelector
      id="aac-chrome"
      currentAccount={currentAccount}
      accounts={regionalAccounts}
      language={formatLocale(internalChromeConfig.locale)}
      onSelect={handleSelect}
    />
  );
};

export default RegionSwitcher;
